import MonthlyReportsService from 'src/modules/monthlyReports/monthlyReportsService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'MONTHLYREPORTS_FORM';

const monthlyReportsFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: monthlyReportsFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await MonthlyReportsService.find(id);
      }

      dispatch({
        type: monthlyReportsFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: monthlyReportsFormActions.INIT_ERROR,
      });

      getHistory().push('/monthly-reports');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: monthlyReportsFormActions.CREATE_STARTED,
      });

      await MonthlyReportsService.create(values);

      dispatch({
        type: monthlyReportsFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.monthlyReports.create.success'),
      );

      getHistory().push('/monthly-reports');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: monthlyReportsFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: monthlyReportsFormActions.UPDATE_STARTED,
      });

      await MonthlyReportsService.update(id, values);

      dispatch({
        type: monthlyReportsFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.monthlyReports.update.success'),
      );

      getHistory().push('/monthly-reports');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: monthlyReportsFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default monthlyReportsFormActions;
